import gql from 'graphql-tag';

export default gql`
  query getSubmissionDetails($submissionId: UUID!, $channelId: UUID!) {
    submissionDetails(submissionId: $submissionId, channelId: $channelId) {
      status
      isCancellable
    }
  }
`;
